export const CameraPlus = () => {
  return (
    <svg
      width={30}
      height={30}
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M27.1356 14.3931V18.1553C27.1356 20.8741 27.1356 22.2334 26.6065 23.2719C26.1411 24.1853 25.3984 24.9279 24.485 25.3934C23.4466 25.9225 22.0872 25.9225 19.3684 25.9225H10.6304C7.91167 25.9225 6.55229 25.9225 5.51386 25.3934C4.60044 24.9279 3.8578 24.1853 3.39239 23.2719C2.86328 22.2334 2.86328 20.8741 2.86328 18.1553V11.8445C2.86328 9.12577 2.86328 7.76639 3.39239 6.72797C3.8578 5.81454 4.60044 5.0719 5.51386 4.60649C6.55229 4.07738 7.91167 4.07738 10.6304 4.07738H15.6062M23.4947 10.1455V2.86377M19.8539 6.50461H27.1356M19.8539 14.9999C19.8539 17.681 17.6805 19.8544 14.9994 19.8544C12.3184 19.8544 10.145 17.681 10.145 14.9999C10.145 12.3189 12.3184 10.1455 14.9994 10.1455C17.6805 10.1455 19.8539 12.3189 19.8539 14.9999Z'
        stroke='#E3DDE6'
        stroke-width='2.42723'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};
